import React, { useEffect, useState, useMemo } from "react";
import * as documentService from "../../../services/documentService";
import { DocumentForm } from "./DocumentForm";
import { connect } from "react-redux";
import * as documentActions from "../../../actions/documentActions";
import { Table } from "@coverme/table";
import { getFriendlyDateFormatWithUtcTime } from "../../../services/dateFormatter";
import { LoadingBar } from "../../../components/LoadingComponents/LoadingBar";
import { WizardButtons } from "../Components/WizardButtons";
import * as fileDownloader from "../../../services/fileDownloader";

function getColumns(hasDeletePermissions, downloadFile, deleteFile) {
    const columns = [
        {
            Header: "Document Type",
            accessor: "documentType",
        },
        {
            Header: "Name",
            accessor: "documentSubType",
        },
        {
            Header: "Uploaded Date",
            accessor: "dateCreated",
            Cell: function UploadedDate({ value }) {
                return getFriendlyDateFormatWithUtcTime(value);
            },
        },
        {
            Header: "Uploaded By",
            accessor: "uploadedBy",
        },
        {
            Header: "actions",
            className: "table__links-row right-aligned-column",
            headerClassName: "table__links-header",
            Cell: function DocumentLinks({ original }) {
                const canDelete = original.canDelete || hasDeletePermissions;
                const { documentId } = original;
                return (
                    <span className="table__links">
                        {canDelete && (
                            <>
                                <a
                                    className="table__link"
                                    href="javascript:void(0)"
                                    onClick={() => deleteFile(documentId)}
                                >
                                    DELETE
                                </a>
                                <span className="table__link-separator"> | </span>
                            </>
                        )}
                        <a className="table__link" href={"javascript:void(0)"} onClick={() => downloadFile(documentId)}>
                            Download
                        </a>
                    </span>
                );
            },
        },
    ];

    return columns;
}

export const InterviewDocumentation = ({
    documents = [],
    documentTypes,
    patientName,
    personId,
    isLoading,
    getDocuments,
    deleteDocument,
    hasDeletePermission,
    navigateToNextPage,
    navigateToPreviousPage,
    customerId,
}) => {
    const [isUploading, setIsUploading] = useState(false);
    useEffect(() => {
        getDocuments(personId);
    }, []);

    function uploadDocument(documentType, documentSubtype, documents) {
        setIsUploading(true);
        documentService.uploadDocument(customerId, personId, documentType, documentSubtype, documents).then(() => {
            getDocuments(customerId, personId);
            setIsUploading(false);
        });
    }

    function downloadFile(documentId) {
        fileDownloader.downloadFile(`/api/person/${personId}/document/${documentId}`, {}, false);
    }

    const columns = useMemo(() => {
        return getColumns(hasDeletePermission, downloadFile, onDelete);
    }, [hasDeletePermission]);

    function onDelete(documentId) {
        return deleteDocument(customerId, personId, documentId);
    }

    return (
        <div className="wizard-page">
            <h2 className="title">Documentation</h2>
            <div className="interview-table-container">
                <div className="table-title" />
                <Table
                    data={documents}
                    columns={columns}
                    loading={isLoading}
                    sortable={false}
                    resizable={false}
                    showPagination={false}
                    defaultPageSize={100}
                    noDataText="No rows found"
                />
            </div>
            <div style={{ position: "relative" }}>
                <LoadingBar isLoading={isUploading}>
                    <div className="inline-form">
                        <h3>Add New Document</h3>
                        <DocumentForm
                            documentTypes={documentTypes}
                            patientName={patientName}
                            onCancel={() => setIsUploading(false)}
                            onSubmit={uploadDocument}
                        />
                    </div>
                </LoadingBar>
            </div>
            <WizardButtons
                formik={{}}
                navigateToNextPage={navigateToNextPage}
                navigateToPreviousPage={navigateToPreviousPage}
                isFirstPage={false}
            />
        </div>
    );
};

export const InterviewDocumentsContainer = connect(
    state => ({
        documents: state.documents.data[state.interview?.entry?.patient?.personId] || [],
        isLoading: state.documents.isLoading === true || state.documents.isInitialized === false,
        documentTypes: state.interviewLookups.data.documentTypes,
        patientName: state.interview.entry.patient.fullName,
        personId: state.interview?.entry?.patient?.personId,
        hasDeletePermission: !!state.user.data.permissions.MARKETPLACE_CAN_DELETE_FILES,
        customerId: state.customer?.data?.customer?.GlobalId,
    }),
    dispatch => ({
        getDocuments: (customerId, personId) => dispatch(documentActions.getDocuments(customerId, personId)),
        deleteDocument: (customerId, personId, documentId) =>
            dispatch(documentActions.deleteDocument(customerId, personId, documentId)),
    })
)(InterviewDocumentation);
